import MyTeamPageMobile from "./myTeamPage.mobile";

function MyTeamPageMain() {
  return <MyTeamPageMobile />;
}

export default MyTeamPageMain;
